import { useDispatch, useSelector } from 'react-redux';
import { getInitData } from '../../redux/init/actions';
import { hasErrorSelector, isFetchingSelector, isReadySelector } from '../../redux/init/selectors';

import t from '../../../text';
import { WithLoadingStates } from './WithLoadingStates';

export const WithInit = ({ children }) => {
  const appIsReady = useSelector(isReadySelector);
  const appIsFetching = useSelector(isFetchingSelector);
  const appHasError = useSelector(hasErrorSelector);
  const dispatch = useDispatch();

  return (
    <WithLoadingStates
      isFetching={appIsFetching}
      hasErrorFetching={appHasError}
      loadingErrorMessage={t('init.errorLoading')}
      onRetry={() => getInitData(dispatch, true)}
      useContainer
    >
      {appIsReady ? children : null}
    </WithLoadingStates>
  );
};
